import type fixture from "@/features/observability-dashboard/data/observability-dashboard-fixture.json";

export type ObservabilityDashboardFixture = typeof fixture;
export type TrafficTrendRow = ObservabilityDashboardFixture["trafficTrend"][number];
export type UsageBreakdownRow = ObservabilityDashboardFixture["usageBreakdown"][number];
export type DrilldownEvent = ObservabilityDashboardFixture["events"][number];
export type RcaCase = ObservabilityDashboardFixture["rcaCases"][number];
export type RcaSignal = RcaCase["signals"][number];

export const DASHBOARD_RANGE_VALUES = ["7", "14"] as const;
export const DASHBOARD_ENVIRONMENT_VALUES = ["all", "production", "staging"] as const;
export const DASHBOARD_APPLICATION_VALUES = [
  "all",
  "prior-authorization",
  "patient-support",
  "claims-operations",
  "referral-scheduling",
] as const;
export const DASHBOARD_CHART_VALUES = [
  "traffic",
  "reliability",
  "safety",
  "risk",
  "quality",
  "usage",
] as const;

export type DashboardRange = (typeof DASHBOARD_RANGE_VALUES)[number];
export type DashboardEnvironment = (typeof DASHBOARD_ENVIRONMENT_VALUES)[number];
export type DashboardApplication = (typeof DASHBOARD_APPLICATION_VALUES)[number];
export type DashboardChart = (typeof DASHBOARD_CHART_VALUES)[number];

export interface PointSelection {
  chart: DashboardChart;
  rowId: string;
  seriesKey: string;
}

export interface ObservabilityTrendRow {
  id: string;
  label: string;
  fullLabel: string;
  rcaId: string;
  requests: number;
  completed: number;
  errors: number;
  p50Latency: number;
  p95Latency: number;
  allowed: number;
  flagged: number;
  blocked: number;
  escalated: number;
  qualityScore: number;
  faithfulnessScore: number;
  relevanceScore: number;
  hallucinationRate: number;
  inputTokens: number;
  outputTokens: number;
  estimatedCost: number;
  driftScore: number;
  missingRate: number;
  invalidRate: number;
  integrityViolations: number;
}

export interface SafetyRiskRow {
  id: string;
  label: string;
  current: number;
  baseline: number;
  trend: number;
  rcaId: string;
}

export interface DataHealthSummary {
  driftScore: number;
  missingRate: number;
  invalidRate: number;
  integrityViolations: number;
}

export interface DrilldownSelection {
  selection: PointSelection;
  label: string;
  metricKey: string;
  metricValue: number;
  comparisonValue: number;
  context: string;
  metrics: Array<{
    labelKey: string;
    value: number;
    format?: "count" | "currency" | "milliseconds" | "percent";
  }>;
  events: DrilldownEvent[];
  rca: RcaCase;
}
